import React, { useState } from 'react'
import { Box, Button, Container, TextField, Typography, AppBar, Toolbar } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useForm } from 'react-hook-form';
import { Login, LoginDataType } from './DataFetch/ManagementAPI';
import { SetSessionID } from './Utility/SessionUtility';

interface FormInputType {
    loginId:string,
    password:string
}

interface PropsType {
    /**
     * ログインフラグ設定関数
     * @param logined true or false
     */
    setLogined: (logined:boolean) => void,
    /**
     * ログインデータ設定関数
     * @param data ログイン時に取得するデータ
     */
    setLoginData: (data:LoginDataType | undefined) => void
}

/**
 * ログイン画面
 */
export function ManagementLogin({setLogined, setLoginData}:PropsType) {

    /**
     * ログイン失敗フラグ
     */
    const [fail, setFail] = useState(false);

    /**
     * フォーム無効化フラグ
     * submit処理が2重で実行されないようにフォームを無効化する
     */
    const [formDisabled, setFormDisabled] = useState<boolean>(false);

    /**
     * 入力フォームHook
     */
    const {register, handleSubmit, formState:{errors}} = useForm<FormInputType>();

    /**
     * 入力フォームエラー文
     */
    const ErrorText: Record<string,string> = {
        "required":"必須項目です。",
        "maxLength":"文字数制限を超えています。"
    }

    /**
     * ログイン処理
     * @param inputData フォームに入力されたデータ
     */
    function onSubmit(inputData:FormInputType) {
        //フォーム無効化
        setFormDisabled(true);

        // ログインAPI実行
        Login({
            loginId: inputData.loginId,
            password: inputData.password
        })
        .then(res => {
            if (res !== undefined) {
                //返り値によってフラグを設定
                setLogined(res.login_permitt);
                setFail(!res.login_permitt);
                setLoginData(res);
                SetSessionID(res.session_id);
            } else {    //undefinedが返ってきたらら失敗
                setLogined(false);
                setFail(true);
                setLoginData(undefined);
            }
            
        })
        .catch(err => {
            console.error(err);
        })
        .finally(() => {
            setFormDisabled(false);
        })
    }

    return(
        <>        
            {/* ヘッダー */}
            <AppBar position="static" color='primary'>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Box>
                            <Typography
                                variant="h6"
                                noWrap
                            >
                                KAGU管理
                            </Typography>
                        </Box>                       
                    </Toolbar>
                </Container>
            </AppBar>

            {/* フォーム */}
            <Container component="main" maxWidth="sm">
                <Box mt={1}>
                    <Typography
                        variant="h6"
                        sx={{
                            mt:2
                        }}
                    >
                        ログイン
                    </Typography>
                    <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
                        <TextField id="mailAddress" label="ユーザーID" variant="outlined" fullWidth
                            margin="normal"
                            sx={{
                                backgroundColor:"white"
                            }}
                            error={errors.loginId ? true : false}
                            helperText={errors.loginId ? ErrorText[errors.loginId.type] : ""}
                            {...register("loginId", {required: true, maxLength: 255})}
                            disabled={formDisabled}
                        />
                        
                        <TextField id="mailAddressConfirm" label="パスワード" variant="outlined" fullWidth
                            type="password"
                            margin="normal"
                            sx={{
                                backgroundColor:"white"
                            }}
                            error={errors.password ? true : false}
                            helperText={errors.password ? ErrorText[errors.password.type] : ""}
                            {...register("password", {required: true, maxLength: 255})}
                            disabled={formDisabled}
                        />

                        <Grid2 container spacing={1} mt={1} alignItems="center">
                            <Grid2>
                                <Button variant="contained" type="submit" disabled={formDisabled}>ログイン</Button>
                            </Grid2>
                            <Grid2 display={fail ? "" : "none"} color="red">
                                ログインに失敗しました
                            </Grid2>
                        </Grid2>
                    </Box>
                </Box>
            </Container>
        </>
    );
}